import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {

    updateReport() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
            const dateFrom = document.getElementById("date_from")
            const dateTo = document.getElementById("date_to")

            if (dateFrom.value != "" && dateTo.value != "" || dateFrom.value == "" && dateTo.value == "") {
                document.getElementById("flash-area").innerHTML = ""
                const jurisdiction = document.getElementById("jurisdiction_id")
                const inspector = document.getElementById("inspector_id")

                let reportUrl = 'chart?title=First%20Pass%20Yield&data_source=permitting_reports_permitting_first_pass_yield_path'

                if (dateFrom.value != "") {
                    reportUrl += '&date_from=' + dateFrom.value + '&date_to=' + dateTo.value
                }
                if (jurisdiction && jurisdiction.value) {
                    reportUrl += '&jurisdiction_id=' + jurisdiction.value
                }
                if (inspector && inspector.value) {
                    reportUrl += '&inspector_id=' + inspector.value
                }

                window.location.href = reportUrl
            } else {
                document.getElementById("flash-area").innerHTML = '<div class="warn">Please select a date range or leave both fields blank.</div>'
                dateFrom.classList.add('required-field')
                dateTo.classList.add('required-field')
            }
        }, 2500)
    }
}
